import React from 'react';
import ColumnQuoteItemPartNumber from './columnQuoteItemPartNumber';
import * as S from '../../styles';

interface ICellPartNumberProps {
  quoteItemPartNumber?: string;
  rowSpan?: number;
  verticalAlign?: 'top' | 'middle' | 'bottom';
}

export default function ColumnPartNumber({
  quoteItemPartNumber,
  rowSpan,
  verticalAlign
}: ICellPartNumberProps) {
  return (
    <S.TableCellGrid
      align="left"
      {...(rowSpan ? { rowSpan } : {})}
      style={{
        borderRight: '2px solid #e0e0e0',
        ...(verticalAlign ? { verticalAlign } : {})
      }}
    >
      <ColumnQuoteItemPartNumber quoteItemPartNumber={quoteItemPartNumber} />
    </S.TableCellGrid>
  );
}
